import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const CARDS = [
  { t: "roles are interpreted differently", n: "01" },
  { t: "candidates are assessed inconsistently", n: "02" },
  { t: "decisions are influenced by opinion rather than evidence", n: "03" },
];

export function Shift({ theme }: { theme: Theme }) {
  return (
    <section style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <SectionHeader
        theme={theme}
        kicker="The shift"
        title="Hiring is a collaborative decision problem."
      />
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 40px" }}>
        <p
          style={{
            fontSize: 19,
            color: theme.fgMute,
            maxWidth: 720,
            lineHeight: 1.55,
            marginBottom: 48,
          }}
        >
          Hiring decisions involve multiple stakeholders, but rarely a shared structure. Without
          alignment:
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 }}>
          {CARDS.map((x) => (
            <div
              key={x.n}
              style={{
                padding: 28,
                background: theme.bg,
                border: `1px solid ${theme.border}`,
                borderRadius: theme.radius,
                minHeight: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontFamily: theme.mono,
                  fontSize: 12,
                  color: theme.fgMute,
                  letterSpacing: 1,
                }}
              >
                {x.n}
              </div>
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  color: theme.fg,
                  letterSpacing: -0.3,
                  lineHeight: 1.25,
                }}
              >
                {x.t}
              </div>
            </div>
          ))}
        </div>
        <p
          style={{
            fontSize: 17,
            color: theme.fgMute,
            maxWidth: 720,
            lineHeight: 1.6,
            marginTop: 40,
          }}
        >
          Improving hiring requires improving how teams define, assess, and decide together.
        </p>
      </div>
    </section>
  );
}
